import { render } from "./need.vue?vue&type=template&id=7157ffad"
import script from "./need.vue?vue&type=script&lang=js"
export * from "./need.vue?vue&type=script&lang=js"

import "./need.vue?vue&type=style&index=0&id=7157ffad&lang=less"
script.render = render

export default script